<footer class="shell-footer section">
  <div class="shell-container shell-footer__grid">
    <div class="shell-footer__brand">
      <img
        class="brand-logo"
        src="assets/shared/images/logo.png"
        alt="Ruffles &amp; Shine logo" />
      <div>
        <p class="shell-footer__lede">
          Ruffles &amp; Shine is a calm, pet-first grooming studio for dogs and cats.
          We pair gentle handling with clear communication so pet parents always feel confident and cared for.
        </p>
      </div>
    </div>

    <div class="shell-footer__column">
      <p class="shell-footer__label">Site Map</p>
      <div class="shell-footer__links">
        <a *ngFor="let link of quickLinks" class="shell-footer__link" [href]="link.href">
          {{ link.label }}
        </a>
      </div>
    </div>

    <div class="shell-footer__column">
      <p class="shell-footer__label">Contact Us</p>
      <div class="shell-footer__contact">
        <p class="shell-footer__text">10 Skylines Village, London, E14 9TS.</p>
        <a class="shell-footer__link" href="tel:9015121315">9015121315</a>
        <a class="shell-footer__link" href="mailto:hello@rufflesandshinegrooming.co.uk">hello@rufflesandshinegrooming.co.uk</a>
      </div>
      <div class="shell-footer__map" aria-label="Map of 10 Skylines Village, London, E14 9TS">
        <iframe
          title="10 Skylines Village map"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=10%20Skylines%20Village%2C%20London%20E14%209TS&output=embed">
        </iframe>
      </div>
    </div>
  </div>

  <div class="shell-footer__meta">
    <span>
      (c) 2025 Ruffles & Shine |
      <a class="shell-footer__link" href="/privacy">Privacy</a> |
      <a class="shell-footer__link" href="/terms">Terms</a>
    </span>
    <span>Crafted for connected pet-care journeys.</span>
  </div>
</footer>
